import React, { memo } from 'react'

import { ArrowLeft } from '@surglogs-app/icons'

import { Button, ButtonProps } from './Button'

export const BackArrowButton = memo(
  ({ variant = 'secondary', ...props }: Omit<ButtonProps, 'ref'>) => (
    <Button
      {...{
        'aria-label': 'back',
        icon: ArrowLeft,
        shape: 'square',
        variant,
      }}
      {...props}
    />
  ),
)
